// extracted by mini-css-extract-plugin
export default {"menuToggle":"Navbar_menuToggle__q1nTk","menu":"Navbar_menu__RhlpJ"};